import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { TrendDimension, ITrendData } from './ITrendData';
import dayjs from 'dayjs';
import { unreachable } from 'src/app/modules/shared/utils/unreachable';
import { CustomCurrencyPipe } from "../../../../store/pipes/custom-currency.pipe";

@Component({
    selector: 'app-consolidation-trend-chart',
    templateUrl: './consolidation-trend-chart.component.html',
    styleUrls: ['./consolidation-trend-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConsolidationTrendChartComponent implements OnInit {
  result: {
    [key: string]: {
      name: string;
      series: {
        name: string;
        value: number;
        extra: {
          areaId: number;
          periodId: string;
        };
      }[];
    }[];
  } = null;

  @Output() reportClicked = new EventEmitter<{
    areaId: number;
    periodId: string;
  }>();

  @Input() set trendData(value: ITrendData) {
    this.result = Object.assign(
      {},
      ...Object.keys(value).map(key => ({
        [key]: value[key as TrendDimension]
          .filter(series => series.label !== 'Compliant')
          .map(series => ({
            name: series.label,
            series: series.data.map(d => ({
              name: d.periodId,
              value: d.y,
              extra: {
                areaId: d.areaId,
                periodId: d.periodId,
              },
            })),
          })),
      })),
    );
  }
  @Input() trendDimension: TrendDimension;
  @Input() currencyCode: string = 'USD';

  dateTickFormatting(val: string) {
    if (val.length === '2020-01'.length) {
      if (dayjs(val + '-01').year() === dayjs().year()) {
        return dayjs(val).format('MMM');
      } else {
        return dayjs(val).format('MMM, YYYY');
      }
    } else {
      return dayjs(val).format('D, MMM');
    }
  }

  valueTickFormatting = (val: number) => {
    switch (this.trendDimension) {
      case '$':
        return `${this.currencyPipe.transform(Math.round(val), this.currencyCode, 'symbol-narrow', '1.0-0')}`;
      case '%':
        return `${Math.round(val)}%`;
      case 'Score':
        return val;
      default:
        unreachable(this.trendDimension);
    }
  };

  onSelect(event: { extra: { areaId: number; periodId: string } }) {
    this.reportClicked.emit({ areaId: event.extra.areaId, periodId: event.extra.periodId });
  }

  formatPeriodId(periodId: string) {
    if (periodId.length === '2020-01'.length) {
      return dayjs(periodId).format('MMM, YYYY');
    } else {
      return dayjs(periodId).format('dddd, MMM DD, YYYY');
    }
  }

  scoreColorScheme = {
    domain: ['#1a237e'],
  };
  consolidationColorScheme = {
    domain: ['#f77b72', '#ffd451', '#82c785'],
  };

  getColorScheme() {
    switch (this.trendDimension) {
      case '$':
      case '%':
        return this.consolidationColorScheme;
      case 'Score':
        return this.scoreColorScheme;
      default:
        unreachable(this.trendDimension);
    }
  }

  constructor(private currencyPipe: CustomCurrencyPipe) {}

  ngOnInit() {}
}
